import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { GlobalConstants, REJECTION_TYPE } from "../../../constants/global-constants";
import { PaymentStatusUpdateAPIModel } from "../../../models/api.model";

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.scss']
})
export class CommentDialogComponent implements OnInit {
  comment: string = ''
  commentList: any
  rejectionType: REJECTION_TYPE | null
  action: string

  constructor(public dialogRef: MatDialogRef<CommentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.commentList = data.comments
    this.action = data?.action
  }

  ngOnInit() {}

  onCloseClick(): void {
    this.dialogRef.close()
  }

  onSave() {
    const statusUpdateInfo: PaymentStatusUpdateAPIModel = {
      comments: this.comment,
      rejectionType: this.rejectionType
  }
    this.dialogRef.close(statusUpdateInfo)
  }

  getKeyValuePairs(obj: any): Array<{ key: string; value: any }> {
    if (!obj) {
      return []
    }
    return Object.keys(obj).map(key => ({ key, value: obj[key] }))
  }

  protected readonly GlobalConstants = GlobalConstants;
}
